import { render, staticRenderFns } from "./AuthorityPage.vue?vue&type=template&id=60132baa&"
import script from "./AuthorityPage.vue?vue&type=script&lang=js&"
export * from "./AuthorityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports